import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import shouldUpdate from 'recompose/shouldUpdate';
import compose from 'recompose/compose';
import FlatButton from 'material-ui/FlatButton';
import ImageEye from 'material-ui/svg-icons/image/remove-red-eye';
import linkToRecord from 'util/linkToRecord';


function ShowButton({ linkTo, showPath = '', label = 'Show', record = {} }) {
  return (
    <FlatButton
      primary
      label={label}
      icon={<ImageEye/>}
      containerElement={
        <Link 
          to={`${linkToRecord(linkTo, record.id)}/${showPath}detail/`}
        />
      }
      style={{overflow: 'inherit'}}
    />
  );
}

ShowButton.propTypes = {
  linkTo: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
};

const enhance = compose(
  shouldUpdate((props, nextProps) => {
    if (!props.record && nextProps.record) {
      return true;
    }
    if (
      props.record
      && nextProps.record
      && props.record.id !== nextProps.record.id
    ) {
      return true;
    }
    if (
      props.record
      && props.linkTo !== nextProps.linkTo
    ) {
      return true;
    }

    return false;
  }),
);

export default enhance(ShowButton);



// WEBPACK FOOTER //
// ./src/components/button/ShowButton.js